import { useDispatch, useSelector } from "react-redux";
import React, { useState } from "react";
import "./tabs.scss"; // Import your CSS file

const Tabs = ({ tabs = [], tabSelect, selectedTabId }) => {
  const handleTabClick = (categoryId) => {
    if (typeof tabSelect === "function") {
      tabSelect(categoryId);
    }
  };
  return (
    <div className="tabs-container">
      <ul className="tab-list">
        {tabs.map((tab) => (
          <li
            key={tab.categoryId}
            className={`tab-item ${tab.categoryId === selectedTabId ? "active" : ""}`}
            onClick={() => handleTabClick(tab.categoryId)}
          >
            {tab.categoryName}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Tabs;
